import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeBossQuery from "@saleor/hooks/makeBossQuery";
import gql from "graphql-tag";

import {
  CustomerActivity,
  CustomerActivityVariables
} from "./types/CustomerActivity";
import {
  CustomerActivityDownload,
  CustomerActivityDownloadVariables
} from "./types/CustomerActivityDownload";
const customerActivityListQuery = gql`
  ${pageInfoFragment}
  query CustomerActivity(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: CustomerActivityFilterInput!
  ) {
    customerActivity(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          id
          email
          first_name
          last_name
          last_login
          last_order_date
          order_status
        }
      }
    }
  }
`;

export const useCustomerActivityQuery = makeBossQuery<
  CustomerActivity,
  CustomerActivityVariables
>(customerActivityListQuery);

const customerActivityDownload = gql`
  ${pageInfoFragment}
  query CustomerActivityDownload(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: CustomerActivityFilterInput!
  ) {
    customerActivity(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          email
          first_name
          last_name
          last_login
          last_order_date
          order_status
          completed_at
          default_mall_name
        }
      }
    }
  }
`;

export const useCustomerActivityDownload = makeBossQuery<
  CustomerActivityDownload,
  CustomerActivityDownloadVariables
>(customerActivityDownload);
